export default __webpack_public_path__ + "static/media/Timetable.bd3efcd0.xlsx";